var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"url":_vm.url,"bg-url":_vm.bgUrl,"bg-align":"right-bottom","content":_vm.content,"section":"网站统计"}})
}
var staticRenderFns = []

export { render, staticRenderFns }